import { useContext, useEffect, useState } from "react";
import { Card, Col, Container, Figure, Row } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import Table from "react-bootstrap/Table";
import Modal from "../Login/Modal/Modal";
import Action from "./Action/Action";
import Stack from "react-bootstrap/Stack";
import FavouriteDropdown from "./Favourite";
import ConfirmDialogButton from "../common/ConfirmDialogButton";
import { Toast } from "react-bootstrap";
import ToastContainer from "react-bootstrap/ToastContainer";
import ConfirmDialogButtonWithEdit from "../common/ConfirmDialogButtonWithEdit";
import PatientMessages from "./PatientMessages";
import { PatientService } from "../../services";
import ProgressBar from "react-bootstrap/ProgressBar";
import { LanguageContext } from "../../utils/Language";

function getPlanTypeName(plantype) {
  if (plantype == "1") return "Express 6";
  else if (plantype == "2") return "Mini 12";
  else if (plantype == "3") return "Küçük 24";
  else if (plantype == "4") return "Orta 36";
  else if (plantype == "5") return "Büyük 48";
  else if (plantype == "6") return "Özel";
  else if (plantype == "7") return "Baskı Başına";

  return "-";
}

export default function PatientDetail() {
  const [actionList, setActionList] = useState([]);
  const [patientDetail, setPatientDetail] = useState({});
  const [resultMessage, setResultMessage] = useState("");
  const [showResultMessage, setShowResultMessage] = useState(false);
  const [messageType, setMessageType] = useState("Primary");
  const params = useParams();
  const [updateFlag, setUpdateFlag] = useState(false);
  const navigate = useNavigate();
  const [printedPercent, setPrintedPercent] = useState(0.0);
  const [printedAdditionalPercent, setPrintedAdditionalPercent] = useState(0.0);
  const [printedOverPercent, setPrintedOverPercent] = useState(0.0);
  const [totalAlignersInPlan, setTotalAlignersInPlan] = useState(0);
  const { dictionary } = useContext(LanguageContext);

  const showMessage = (message, type) => {
    setResultMessage(message);
    setMessageType(type);
    setShowResultMessage(true);
  };

  const addNewRevision = () => {
    navigate("/newpatient/" + params.Id);
  };
  const requestAligners = (note) => {
    PatientService.requestAligners(params.Id, note).then((json) => {
      showMessage("Aligner request sent succesfully.", "primary");
    });
  };

  const orderMissingAligners = (note) => {
    requestAligners("Order missing aligners: " + note);
  };

  const sendMessageForPatient = (message) => {
    PatientService.sendMessageForPatient(params.Id, message)
      .then((json) => {
        showMessage("Your message sent successfully.", "primary");
        setUpdateFlag(!updateFlag);
      })
      .catch((err) => showMessage("Unknown error.", "danger"));
  };

  const archievePatient = (addToArsiv) => {
    PatientService.archievePatient(params.Id, addToArsiv).then((data) => {
      setPatientDetail(data);
      setUpdateFlag(!updateFlag);
    });
  };

  useEffect(() => {
    PatientService.getPatientDetail(params.Id).then((response) => {
      var p = response[0];
      p.PlanType = getPlanTypeName(p.PlanType);

      var planed = p.Planed ? parseFloat(p.Planed) : 0.0;
      var extra = p.EkstraN ? parseFloat(p.EkstraN) : 0.0;
      var printed = p.Printed ? parseFloat(p.Printed) : 0.0;

      setTotalAlignersInPlan(planed + extra);

      var remaining = printed;
      if (remaining < planed) {
        setPrintedPercent(remaining);
        remaining = 0;
      } else {
        setPrintedPercent(planed);
        remaining = remaining - planed;
      }

      if (remaining < extra) {
        setPrintedAdditionalPercent(remaining);
        remaining = 0;
      } else {
        setPrintedAdditionalPercent(extra);
        remaining = remaining - extra;
      }

      var over = remaining;
      setPrintedOverPercent(over);

      setPatientDetail(p);
    });

    PatientService.getPatientActionHistory(params.Id).then((response) =>
      setActionList(response)
    );
  }, [updateFlag]);

  return (
    <>
      <ToastContainer className="mb-5 position-fixed" position="bottom-center">
        <Toast
          onClose={() => setShowResultMessage(false)}
          show={showResultMessage}
          bg={messageType}
          delay={3000}
          autohide
        >
          <Toast.Body>{resultMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
      <div>
        <Row>
          <Col className="col-12 col-md-8">
            <Card>
              <Card.Header as="h3">{dictionary.PatientDetails}</Card.Header>
              <Card.Body>
                <Stack gap={2} direction="horizontal">
                  <Stack className="col-md-1">
                    <Figure>
                      <Figure.Image width={100} height={150} />
                    </Figure>
                    <FavouriteDropdown
                      fav={patientDetail["Favori"]}
                      patientId={patientDetail["Id"]}
                    />
                  </Stack>
                  <Stack className="col-lg-6">
                    <Table size="sm" striped="columns" bordered hover>
                      <tbody>
                        {Object.keys(dictionary["detailPageFields"]).map(
                          (key) => {
                            return (
                              <tr key={key}>
                                <th>{dictionary.detailPageFields[key]}</th>
                                <td>{patientDetail[key]}</td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    </Table>
                    <ProgressBar>
                      <ProgressBar
                        max={totalAlignersInPlan}
                        animated
                        striped
                        variant="success"
                        now={printedPercent}
                        label={printedPercent}
                        key={1}
                      />
                      <ProgressBar
                        max={totalAlignersInPlan}
                        animated
                        striped
                        variant="warning"
                        now={printedAdditionalPercent}
                        label={printedAdditionalPercent}
                        key={2}
                      />
                      <ProgressBar
                        max={100}
                        animated
                        striped
                        variant="danger"
                        now={printedOverPercent}
                        label={printedOverPercent}
                        key={3}
                      />
                    </ProgressBar>
                  </Stack>
                </Stack>
              </Card.Body>
            </Card>
          </Col>
          <Col className="col-12 col-md-4">
            <Stack>
              {/* Work Card Preview */}
              <ConfirmDialogButton
                variant="primary"
                style={{ width: "100%", margin: "2px" }}
                title={dictionary.RequestRevision}
                body={dictionary.RequestRevisionQuestion}
                onClick={addNewRevision}
              >
              {dictionary.SendAdditionalScan}
              </ConfirmDialogButton>

              <ConfirmDialogButton
                variant="primary"
                disabled={patientDetail.ActionId != 0}
                style={{ width: "100%", margin: "2px" }}
                title={dictionary.RequestRevision}
                body={dictionary.RequestRevisionQuestion}
                onClick={addNewRevision}
              >
                {dictionary.RequestRevision}
              </ConfirmDialogButton>
              <ConfirmDialogButtonWithEdit
                disabled={patientDetail.ActionId != 0}
                variant="primary"
                style={{ width: "100%", margin: "2px" }}
                title={dictionary.RequestAligners}
                noteTitle={dictionary.RequestAlignersNote}
                body={dictionary.RequestAlignersQuestion}
                onClick={(note) => requestAligners(note)}
              >
                {dictionary.RequestAligners}
              </ConfirmDialogButtonWithEdit>
              <ConfirmDialogButtonWithEdit
                disabled={patientDetail.ActionId != 0}
                variant="primary"
                style={{ width: "100%", margin: "2px" }}
                title={dictionary.OrderMissingAligners}
                body={dictionary.OrderMissingAlignersQuestion}
                noteTitle={dictionary.OrderMissingAlignersNote}
                onClick={(note) => orderMissingAligners(note)}
              >
                {dictionary.OrderMissingAligners}
              </ConfirmDialogButtonWithEdit>
              <ConfirmDialogButtonWithEdit
                variant="primary"
                style={{ width: "100%", margin: "2px" }}
                title={dictionary.SendMessageAboutPatient}
                noteTitle={dictionary.SendMessageAboutPatientNote}
                body={dictionary.SendMessageAboutQuestion}
                onClick={(message) => sendMessageForPatient(message)}
              >
                {dictionary.SendMessageAboutPatient}
              </ConfirmDialogButtonWithEdit>
              {patientDetail.ClientState % 10 == 0 && (
                <ConfirmDialogButton
                  disabled={patientDetail.ActionId != 0}
                  variant="danger"
                  style={{ width: "100%", margin: "2px" }}
                  title={dictionary.ArchievePatient}
                  body={dictionary.ArchivePatientQuestion}
                  onClick={() => archievePatient(true)}
                >
                  {dictionary.ArchivePatient}
                </ConfirmDialogButton>
              )}
              {patientDetail.ClientState % 10 == 5 && (
                <ConfirmDialogButton
                  disabled={patientDetail.ActionId != 0}
                  variant="primary"
                  style={{ width: "100%", margin: "2px" }}
                  title={dictionary.MoveToPatientList}
                  body={dictionary.MoveToPatientListDetail}
                  onClick={() => archievePatient(false)}
                >
                  {dictionary.MoveToPatientList}
                </ConfirmDialogButton>
              )}
            </Stack>
          </Col>
        </Row>
        <Stack className="mt-3">
          <Row>
            <Col className="col-12 col-md-6">
              <h3>{dictionary.PatientHistory}</h3>
              {actionList &&
                actionList
                  .sort(
                    (a, b) => new Date(b.SystemDate) - new Date(a.SystemDate)
                  )
                  .map((action, index) => {
                    return (
                      <Action
                        key={action.Id}
                        actionId={patientDetail.ActionId}
                        readonly={patientDetail.ActionStep != 7 || index != 0}
                        patientDetails={patientDetail}
                        {...action}
                      />
                    );
                  })}
            </Col>
            <Col className="col-12 col-md-6">
              <PatientMessages
                patientId={params.Id}
                refresh={updateFlag}
              ></PatientMessages>
            </Col>
          </Row>
        </Stack>
      </div>
    </>
  );
}
